import React from 'react'
import { Modal, ModalHeader } from 'reactstrap';
import { FormCedula } from '../../../components/users/FormCedula';
import { Dialog } from 'primereact/dialog';

export const ModalCedula = (props) => {
    const {
        modalCedula, toggleCedula,modalTitleCard, typeCedula, handleInputChange, professional_license, userId , saveProfessionalLicense, handleInputChangeC, formValuesC
    } = props;
        console.log("🚀 ~ ModalCedula1 ~ toggleCedula1:", toggleCedula)
    

    console.log("ModalCedula isOpen: ", modalCedula);

    return (
        <Dialog
            visible={modalCedula} 
            onHide={toggleCedula} 
            header={modalTitleCard}
                headerStyle={{
                backgroundColor: '#0d3b59',
                color: 'white',
                fontWeight: 'bold'
            }}
            pt={{
                header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
                headerIcon: { style: { color: 'white' } },
            }}
            className="small-dialog"
        >

            {
                typeCedula === "typeCedula"
                    ?
                    <FormCedula button='Guardar' {...{ toggleCedula, modalCedula, professional_license, userId , saveProfessionalLicense, handleInputChangeC,typeCedula, formValuesC
                    }} />
                    : ""
            }

        </Dialog>
    );
};

